import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { KeyValuePairEnum } from '../../models/key-value-pair-enum';
import { CFSignatureForComplete } from '../../models/signatures/cf-signature-for-complete';
import { CFSignatureForInit } from '../../models/signatures/cf-signature-for-init';
import { Constants } from '../../util/constants';
import { b64toArrayBuffer } from '../../util/utils';

@Injectable({ providedIn: 'root' })
export class CFSignatureService {
    private apiUrl = environment.apiUrl + '/api/documents';

    constructor(private http: HttpClient) {}

    getSignatureTypes(): Observable<Array<KeyValuePairEnum>> {
        return this.http.get<Array<KeyValuePairEnum>>(`${this.apiUrl}/signatures/signature-types`);
    }

    initiateSignature(cloudFlowId: string, sectionId: string, signatureForInit: CFSignatureForInit): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/${cloudFlowId}/signatures/section/${sectionId}`, signatureForInit);
    }

    completeSignature(cloudFlowId: string, signatureId: string, signatureForComplete: CFSignatureForComplete): Observable<any> {
        const formData = new FormData();

        if (signatureForComplete.fileOnGlass) {
            const blobFile = new Blob([b64toArrayBuffer(signatureForComplete.fileOnGlass.fileBase64)], {
                type: Constants.IMAGE_MIME_TYPE
            });
            formData.append('file', blobFile, signatureForComplete.fileOnGlass.fileName);
        } else if (signatureForComplete.payload) {
            formData.append('payload', signatureForComplete.payload);
        }

        return this.http.patch(`${this.apiUrl}/${cloudFlowId}/signatures/${signatureId}/complete`, formData);
    }
}
